import { render, staticRenderFns } from "./SlideConfiguration.vue?vue&type=template&id=1c9378f6&scoped=true"
import script from "./SlideConfiguration.vue?vue&type=script&lang=js"
export * from "./SlideConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SlideConfiguration.vue?vue&type=style&index=0&id=1c9378f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9378f6",
  null
  
)

export default component.exports